import { useCallback, useContext, useMemo, useState } from 'react';
import { useFloating } from '@floating-ui/react';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import { Portal } from '../Portal/index.js';
import { useZIndexMiddleware } from '../presentation/popper-modifiers';
import { ProjectClipsFiltersContext } from '../../contexts/project-clips/Context';
import { AdditionalFiltersMenu } from './AdditionalFilters.Menu';
import { FilterIconButton } from './FilterIconButton';

export const AdditionalFilters = () => {
  const filters = useContext(ProjectClipsFiltersContext);
  const [filterMenuOpen, setFilterMenuOpen] = useState(false);

  const hasAdditionalFilters = useMemo(
    () => filters.groupTagIds.length > 0 || filters.speakerRole !== 'all',
    [filters.speakerRole, filters.groupTagIds]
  );

  const zIndexMiddleware = useZIndexMiddleware(8);
  const { refs, floatingStyles } = useFloating({
    open: filterMenuOpen,
    onOpenChange: setFilterMenuOpen,
    middleware: [zIndexMiddleware],
    placement: 'bottom-start',
  });

  const handleBlur = useCallback(() => setFilterMenuOpen(false), []);
  const handleFilterClick = useCallback(() => setFilterMenuOpen(true), []);

  return (
    <>
      <div ref={refs.setReference} onClick={handleFilterClick}>
        <FilterIconButton isActive={hasAdditionalFilters} />
      </div>
      {filterMenuOpen && (
        <Portal>
          <ClickAwayListener mouseEvent="onMouseDown" onClickAway={handleBlur} touchEvent="onTouchStart">
            <div ref={refs.setFloating} style={floatingStyles}>
              <AdditionalFiltersMenu onClose={handleBlur} />
            </div>
          </ClickAwayListener>
        </Portal>
      )}
    </>
  );
};

AdditionalFilters.displayName = 'ProjectClips.AdditionalFilters';
